import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import NotificationUtils from 'utils/NotificationUtils';
import MobileAppInteractor from 'utils/MobileAppInteractor';

import RestaurantStore from 'stores/RestaurantStore';

import OrderAction from 'actions/OrderAction';

// -- entities
import Order from 'PMT/entities/order/Order';
import OrderSettings from 'PMT/entities/order/OrderSettings';

// -- views
import { Modal } from 'react-bootstrap';
import OnLoadingContentViewForModal from 'PMT/components/OnLoadingContentViewForModal';
import OrdersToMakeList from './OrdersToMakeList';

/**
*
*/
export default class NotifyOrdersToMakeModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    orders: PropTypes.arrayOf(Order).isRequired,

    orderSettings: PropTypes.objectOf(OrderSettings).isRequired,
    currencyCode: PropTypes.string,

  };

  state = {
    isLoading: false
  };

  componentDidMount() {
    NotificationUtils.notifyNewOrder();
  }

  //
  //
  //

  onValidate = () => {
    this.setState({
      isLoading: true
    });

    NotificationUtils.stopNotifyNewOrder();

    if (MobileAppInteractor.printerIsAvailable()) {
      const restaurant = RestaurantStore.getRestaurant();
      _.each(this.props.orders, (order) => {
        MobileAppInteractor.printOrder(order, restaurant);
      })
    }

    _.each(this.props.orders, (order: Order) => {
      order.status = Order.OrderStatus.RECEIVED;
      OrderAction.updateOrder(order);
    });
  };

  //
  // renderers
  //

  renderList() {
    return (
      <OrdersToMakeList
        orders={this.props.orders}
        orderSettings={this.props.orderSettings}
        currencyCode={this.props.currencyCode}
      />
    );
  }

  renderBody() {
    if (this.state.isLoading) {
      return (<OnLoadingContentViewForModal />);
    }

    return (
      <div>
        {this.renderList()}

        <div className="text-center">
          <button
            className="btn btn-primary btn-lg"
            onClick={this.onValidate}
          >
            Accepter
          </button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={() => { /* do nothing */ }}
      >
        <Modal.Header>
          <Modal.Title>
            {this.props.orders.length === 1 &&
              <span>Nouvelle commande</span>
            }
            {this.props.orders.length > 1 &&
              <span>Nouvelles commandes</span>
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
      );
    }
  }



// WEBPACK FOOTER //
// ./scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/index.js